import React from 'react';
import { motion } from 'framer-motion';

const WHATSAPP_NUMBER = '16822039297';
const WHATSAPP_MESSAGE = 'Hola Legatum Coffee ☕, tengo una duda sobre los perfiles de café o sobre mi pedido...';

const WhatsAppFloat = () => {
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Escríbenos por WhatsApp"
      data-testid="whatsapp-float"
      initial={{ opacity: 0, scale: 0.6, y: 40 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 0.8, type: 'spring', stiffness: 200, damping: 18 }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.94 }}
      className="fixed z-40 bottom-6 right-6 md:bottom-8 md:right-8 flex items-center justify-center"
      style={{
        width: '58px',
        height: '58px',
        borderRadius: '50%',
        background: '#25D366',
        boxShadow: '0 6px 20px rgba(37, 211, 102, 0.45), 0 2px 6px rgba(0, 0, 0, 0.15)',
      }}
    >
      {/* Pulsing halo */}
      <span
        aria-hidden="true"
        className="absolute inset-0 rounded-full animate-ping"
        style={{ background: '#25D366', opacity: 0.35 }}
      />
      {/* Official WhatsApp glyph (SVG) */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        width="30"
        height="30"
        style={{ position: 'relative', display: 'block' }}
        aria-hidden="true"
      >
        <path
          fill="#FFFFFF"
          d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.638 3.482 4.673 4.415.617.287 2.147.86 2.82.86.62 0 2.192-.734 2.42-1.29.16-.404.14-.856.062-1.277-.06-.334-2.35-1.492-2.686-1.492zm-2.653 5.4h-.017c-1.532 0-3.036-.415-4.34-1.196l-.31-.185-3.223.836.855-3.174-.2-.32a8.649 8.649 0 0 1-1.32-4.615c0-4.804 3.912-8.71 8.717-8.71a8.667 8.667 0 0 1 6.157 2.55 8.6 8.6 0 0 1 2.548 6.16c-.005 4.807-3.917 8.712-8.706 8.712M22 8.44a11.043 11.043 0 0 0-11.755-2.5c-4.174 1.606-6.912 5.66-6.784 10.048.03 1.741.575 3.44 1.464 4.938L3 27.4l6.135-1.582a10.98 10.98 0 0 0 5.336 1.365c5.86 0 10.62-4.75 10.62-10.6a10.55 10.55 0 0 0-3.09-7.51"
        />
      </svg>
    </motion.a>
  );
};

export default WhatsAppFloat;
